import envConfig from './kitt.config.json' with { type: 'json' };

export type AppEnv = 'local' | 'local-payment' | 'development' | 'qa' | 'production' | 'staging';

export type EnvConfig = {
  appEnv: AppEnv;
  analyzeBundle: boolean;
};

export const EnvConfig = envConfig as unknown as EnvConfig;
